import { useRouter } from "@edreamsodigeo/frontend-core";

import { removeURLParameter } from "../../../../tools/removeUrlParameter";

const LOGIN_CONFIRMATION_PARAM = "lcp";

const useIncentivizeLoginConfirmationParam = (): {
  hasLoginConfirmationParam: boolean;
  getLoginConfirmationUrl: () => URL;
  removeLoginConfirmationParam: VoidFunction;
} => {
  const { query } = useRouter();

  const getLoginConfirmationUrl = (): URL => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set(LOGIN_CONFIRMATION_PARAM, "true");
    return currentUrl;
  };

  const removeLoginConfirmationParam = (): void => {
    removeURLParameter(LOGIN_CONFIRMATION_PARAM);
  };

  return {
    hasLoginConfirmationParam:
      !!query[LOGIN_CONFIRMATION_PARAM] &&
      query[LOGIN_CONFIRMATION_PARAM] === "true",
    getLoginConfirmationUrl,
    removeLoginConfirmationParam,
  };
};

export default useIncentivizeLoginConfirmationParam;
